/*
  src/redux/notifications/constants.js

  Created by erikchristensen on 11/22/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

function createConstant(action){
  return ['portal', 'notifications', action].join('/');
}

export const NOTIFICATION_SHOWN = createConstant('NOTIFICATION_SHOWN');
export const NOTIFICATION_DISMISSED = createConstant('NOTIFICATION_DISMISSED');



// WEBPACK FOOTER //
// ./src/shared/redux/notifications/constants.js